/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Desk_AddInputs */

const en_features_desk_add = /** @type {(inputs: Features_Desk_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add exercise`)
};

const pl_features_desk_add = /** @type {(inputs: Features_Desk_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dodaj ćwiczenie`)
};

/**
* | output |
* | --- |
* | "Add exercise" |
*
* @param {Features_Desk_AddInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_desk_add = /** @type {((inputs?: Features_Desk_AddInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Desk_AddInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_desk_add(inputs)
	return en_features_desk_add(inputs)
});